function playVideo(element) {
    const blockId = element.closest('.grid__item').id.split('-').pop();
    const videoModal = document.getElementById(`video-modal-${blockId}`);
    const videoContainer = document.getElementById(`video-container-${blockId}`);
    const videoType = element.getAttribute('data-video-type');
    const videoUrl = element.getAttribute('data-video-url');
    const aboutUsSection = document.querySelector('.section-about-us');

    if (videoType === 'file') {
        const videoPlayer = document.querySelector('.video-file-player');
        if (videoPlayer) {
            videoPlayer.autoplay = true;
            videoPlayer.loop = true;
            videoPlayer.muted = true;
        }
    } else if (videoType === 'youtube') {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoUrl}?autoplay=1`;
        iframe.frameBorder = '0';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        videoContainer.appendChild(iframe);
    } else if (videoType === 'vimeo') {
        const iframe = document.createElement('iframe');
        iframe.src = `https://player.vimeo.com/video/${videoUrl}?autoplay=1`;
        iframe.frameBorder = '0';
        iframe.allow = 'autoplay; fullscreen';
        iframe.allowFullscreen = true;
        videoContainer.appendChild(iframe);
    }

    videoModal.style.display = 'block';
    videoContainer.style.display = 'block';
    aboutUsSection.style.position = 'relative';
    aboutUsSection.style.zIndex = '9999';

    // Disable body scroll
    document.body.style.overflow = 'hidden';
}

function closeModal(element) {
    const blockId = element.closest('.grid__item').id.split('-').pop();
    const videoModal = document.getElementById(`video-modal-${blockId}`);
    const videoContainer = document.getElementById(`video-container-${blockId}`);
    const videoType = element.getAttribute('data-video-type');
    const aboutUsSection = document.querySelector('.section-about-us');

    if (videoType === 'youtube' || videoType === 'vimeo') {
        const iframe = videoContainer.querySelector('iframe');
        if (iframe) {
            iframe.src = '';
        }
        videoContainer.innerHTML = '';
    } else {
        const videoPlayer = document.querySelector('.video-file-player');
        if (videoPlayer) {
            videoPlayer.pause();
            videoPlayer.currentTime = 0;
        }
    }

    videoModal.style.display = 'none';
    videoContainer.style.display = 'none';
    aboutUsSection.style.position = 'relative';
    aboutUsSection.style.zIndex = '1';

    // Enable body scroll
    document.body.style.overflow = '';
}